/**
 * Server-safe column ids + table display defaults for DEFAULT_USER_DISPLAY_PREFERENCES.
 * Keep in sync with ./columns.tsx.
 */

export const faculty_role_user_column_display_seeds: {
    id: string;
    defaultDisplayPreferences: {
        order: number;
        size: number;
        visible: boolean;
        pinned: boolean;
        displayAs: "number" | "string" | "date" | "other";
    };
}[] = [
    {
        id: "user",
        defaultDisplayPreferences: {
            order: 1,
            size: 300,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
];
